export const galleryImages = [
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744132443/bedroom-guest_meeqsk.jpg",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744132845/drawaing-room-side-view_gojnui.jpg",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744132845/drawing-room_g5pjxe.jpg",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744132845/drawing-room-front_wrgmhr.jpg",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744132845/PPK-Ground-V2-Dining-room-20241110-204121-logo_o6tb7e.png",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744132845/PPK-Ground-V2-Dining-room-20241110-225706-logo_bob8yy.png",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744133520/MBR-1-logo_swe7hq.png",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1744132846/PPK-kitchen-logo_y94l3d.png",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1758457746/4514f05a-36db-492c-b3e3-497d1e83623b_h9aev5.jpg",
  "https://res.cloudinary.com/dhvawsxez/image/upload/v1758457757/63528486-4725-4eba-bacc-9f85fc5323a1_owv0cj.jpg",
];
